import React, {useState, useEffect} from 'react'

import classes from './Activity.module.css'
import ActivityTitle from '../ActivityTitle/ActivityTitle';
import Button from '@/components/shared/Button/Button';
import ActivityDebrief from '../ActivityDebrief/ActivityDebrief';
import { observer } from 'mobx-react-lite';
import AppState from '@/js/AppState';
import ActivityPedaInstance from 'react-sdk/activities/ActivityPedaInstance';
import Minigames from '@/js/Minigames/Minigames';
import clsx from 'clsx';
import ActivityFeedback from '../ActivityFeedback/ActivityFeedback';

// NOTE : composant affichant une activité péda en 3 étapes :
// * step 0 affichage de la question
// * step 1 affichage du jeu
// * step 2 affichage du bouton next à la fin du jeu
// * step 3 affichage du debrief et du bouton finir


const STEPS = {
  QUESTION: 0,
  GAME: 1,
  VALIDATE_GAME: 2,
  DEBRIEF: 3,
}


/**
* @param {object} props
* @param {ActivityPedaInstance} props.instance
* @param {boolean} props.showMediaInTitle
* @param {Function} props.onFinished
*/
const Activity = ({instance, GameComponent, showMediaInTitle=true, onFinished}) => {

  const [step, setStep] = useState(STEPS.GAME);

  useEffect(() => {
    setStep(STEPS.GAME)
    instance.reset()
  }, [instance]);

  function correct() {
    instance.localCorrect()
  }

  function handleReadyToValidate(val) {
    // console.log("handleReadyToValidate", val)
    setStep(val ? STEPS.VALIDATE_GAME : STEPS.GAME)
  }



  return (
    <div className={clsx(classes.Activity, classes[step])}>
      {AppState.debugMode && <button onClick={onFinished} style={{position: "absolute", top: 0, right: 0}}>close {instance?.ID}</button>}

      {step >= STEPS.QUESTION &&
      <ActivityTitle activity={instance} showMedia={showMediaInTitle} />}

      {step >= STEPS.GAME &&
      <div className={classes.game}>
        <GameComponent
          instance={instance}
          onReadyToValidate={handleReadyToValidate} />
      </div>}

      {instance.result &&
      <div className={classes.debrief}>
        <ActivityFeedback correct={instance.result.is_correct} />
        <ActivityDebrief instance={instance} />
      </div>}

      <div className={classes.btns_ctnr}>
        {step === STEPS.QUESTION && <Button onClick={() => setStep(1)} >Continuer</Button>}
        {(step === STEPS.VALIDATE_GAME && !instance.result) && <Button onClick={correct} >Valider</Button>}

        {instance.result &&
        <Button onClick={onFinished} >
          Continuer
          {/* {(Minigames.currentGroup &&
            Minigames.currentGroup.findCurrentMinigameIndex(Minigames.current) === Minigames.currentGroup.children.length - 1) ?
            "Finir" : "Suivant"}

          {!Minigames.currentGroup && "Quitter"} */}

        </Button>}

      </div>

    </div>
  );
};

export default observer(Activity)
